export const BLOOD_TYPE_OPTIONS = [
  { value: 'A+', label: 'A형 Rh+' },
  { value: 'A-', label: 'A형 Rh-' },
  { value: 'B+', label: 'B형 Rh+' },
  { value: 'B-', label: 'B형 Rh-' },
  { value: 'O+', label: 'O형 Rh+' },
  { value: 'O-', label: 'O형 Rh-' },
  { value: 'AB+', label: 'AB형 Rh+' },
  { value: 'AB-', label: 'AB형 Rh-' },
] as const;

export const isSupportedBloodType = (value?: string): boolean =>
  BLOOD_TYPE_OPTIONS.some((option) => option.value === value);
